import { getComposeStore } from 'owa-calendar-compose-store-manager';
import { FULL_COMPOSE_FORM_TYPE } from 'owa-calendar-helpers-types/lib/ComposeTypes';

/**
 * Checks if FullCompose form is open
 */
export default function isFullComposeOpen(): boolean {
    const { openedForm } = getComposeStore();
    return openedForm == FULL_COMPOSE_FORM_TYPE;
}
